import { useCallback, useEffect, useMemo, useState } from 'react'
import {
    normalizeProductId,
    subscribeClosedProducts,
    subscribeProductDates,
} from '../../common/closedProducts'

export default function useAwardedProducts() {
    const [closedProducts, setClosedProducts] = useState({})
    const [productDates, setProductDates] = useState({})

    useEffect(() => subscribeClosedProducts(setClosedProducts), [])
    useEffect(() => subscribeProductDates(setProductDates), [])

    const withUpdatedDates = useCallback(
        (product) => {
            const id = [product?.id, product?.pid, product?.product_id]
                .map(normalizeProductId)
                .find(Boolean)
            return id && productDates[id] ? { ...product, ...productDates[id] } : product
        },
        [productDates],
    )

    const awardStates = useMemo(
        () =>
            Object.fromEntries(
                Object.entries(closedProducts).map(([id, { status }]) => [id, status]),
            ),
        [closedProducts],
    )

    return { awardStates, closedProducts, withUpdatedDates }
}
